const ApplicationDatabaseSource = {
    Unknown: 0,
    Active: 1,
    Archived: 2
};

Object.freeze(ApplicationDatabaseSource);

export default ApplicationDatabaseSource;